/**
 * External Dependencies
 */
import React, { Component } from 'react';
import 'animate.css';
/**
 * Internal Dependencies
 */
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageContent from '../../components/page-content';
import PageTitle from "../../components/page-title";
import PageWrapFortran from "../../components/page-wrap-fortran";
import PageContentFortran from "../../page-content-fortran";
import AsyncComponentFortran from "../../async-component-fortran";

/**
 * Component
 */
class NovaVendaPage extends Component {
    render() {
        return (
            <PageWrap>
                <PageTitle breadcrumbs={ {
                    '/': 'Home',
                } }>
                    <h1>Vendas</h1>
                </PageTitle>
                <PageContent>
                    <AsyncComponentFortran component={ () => import( './content' ) } />
                </PageContent>
            </PageWrap>
        );
    }
}

export default NovaVendaPage;
